/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';
import type { SigningLookupsViewModel } from './SigningLookupsViewModel';
import {
    SigningLookupsViewModelFromJSON,
    SigningLookupsViewModelFromJSONTyped,
    SigningLookupsViewModelToJSON,
} from './SigningLookupsViewModel';

/**
 * 
 * @export
 * @interface ResultOfSigningLookupsViewModel
 */
export interface ResultOfSigningLookupsViewModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfSigningLookupsViewModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfSigningLookupsViewModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfSigningLookupsViewModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfSigningLookupsViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfSigningLookupsViewModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfSigningLookupsViewModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfSigningLookupsViewModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {SigningLookupsViewModel}
     * @memberof ResultOfSigningLookupsViewModel
     */
    data?: SigningLookupsViewModel;
    /**
     * 
     * @type {number}
     * @memberof ResultOfSigningLookupsViewModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfSigningLookupsViewModel interface.
 */
export function instanceOfResultOfSigningLookupsViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfSigningLookupsViewModelFromJSON(json: any): ResultOfSigningLookupsViewModel {
    return ResultOfSigningLookupsViewModelFromJSONTyped(json, false);
}

export function ResultOfSigningLookupsViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfSigningLookupsViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : SigningLookupsViewModelFromJSON(json['Data']),
        'count': json['Count'],
    };
}

export function ResultOfSigningLookupsViewModelToJSON(value?: ResultOfSigningLookupsViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': SigningLookupsViewModelToJSON(value.data),
        'Count': value.count,
    };
}

